import { Component, Vue } from 'vue-property-decorator';
import { ShipmentFields } from '@/types/graphql/schemaTypes';
@Component
export default class FromTo extends Vue {
  public fromTo(shipment: ShipmentFields) {
    return [
      shipment.departurePlace ? shipment.departurePlace.name : '',
      shipment.arrivalPlace ? shipment.arrivalPlace.name : ''
    ].join(' - ');
  }
}
